import { useEffect } from 'react';
import { useCaptchaContext } from "../../../../entities/captcha/model";
import { addMessage, selectHistory } from "../../../../entities/message/model";
import { getMockOperatorInitialMessage } from "../../../../shared/api";
import { getLastSession } from "../../../../shared/lib";
import { FSMStages, useAppDispatch, useAppSelector, useFSM } from "../../../../shared/model";
import { selectChatCofig } from "../../../../entities/settings/model";
export var useStartOperatorMessage = function useStartOperatorMessage() {
  var _useCaptchaContext = useCaptchaContext(),
    captchaStage = _useCaptchaContext.captchaStage;
  var _useFSM = useFSM(),
    stage = _useFSM.stage;
  var _useAppSelector = useAppSelector(selectChatCofig),
    authZoneConfig = _useAppSelector.authZoneConfig,
    welcomeMessage = _useAppSelector.welcomeMessage;
  var _ref = authZoneConfig || {},
    showMessageBeforeInput = _ref.showMessageBeforeInput,
    zoneType = _ref.zoneType,
    startMessage = _ref.startMessage;
  var dispatch = useAppDispatch();
  var _ref2 = getLastSession(useAppSelector(selectHistory)) || {
      messages: []
    },
    messages = _ref2.messages;
  useEffect(function () {
    if (!welcomeMessage) {
      return;
    }
    var initialMessage = getMockOperatorInitialMessage(welcomeMessage !== null && welcomeMessage !== void 0 ? welcomeMessage : startMessage);
    var hasMockOperatorInitialMessage = messages === null || messages === void 0 ? void 0 : messages.find(function (el) {
      return el.messageId === initialMessage.messageId;
    });
    if (zoneType === 'unauthorized' && stage === FSMStages.CAPTCHA_NEEDED && captchaStage === 'init' &&
    // Вставляем сообщение если мы его не вставляли + если есть стартовое сообщение в нз первым делом выводим его
    !hasMockOperatorInitialMessage && showMessageBeforeInput) {
      dispatch(addMessage(initialMessage));
    }
  }, [stage, captchaStage, messages.length, welcomeMessage, zoneType]);
};